import React, { useState } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Terms from './Terms.jsx';
import Privacy from './Privacy.jsx';
import './App.css';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="font-sans">
      {/* Navbar */}
      <nav className="bg-teal-900 shadow-md sticky top-0 z-50 transition-all duration-300">
        <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
          <Link
            to="/"
            className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-amber-400 to-amber-200 hover:from-amber-300 hover:to-amber-100 transition-all duration-300"
          >
            SALINAS TRADING LLC
          </Link>
          <div className="hidden md:flex space-x-8">
            <Link
              to="/"
              className="text-slate-100 hover:text-amber-400 relative group transition-colors duration-300"
            >
              Home
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-amber-400 group-hover:w-full transition-all duration-300"></span>
            </Link>
            <Link
              to="/terms-and-conditions"
              className="text-slate-100 hover:text-amber-400 relative group transition-colors duration-300"
            >
              Terms
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-amber-400 group-hover:w-full transition-all duration-300"></span>
            </Link>
            <Link
              to="/privacy-policy"
              className="text-slate-100 hover:text-amber-400 relative group transition-colors duration-300"
            >
              Privacy
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-amber-400 group-hover:w-full transition-all duration-300"></span>
            </Link>
          </div>
          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-slate-100 focus:outline-none"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d={isMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'}
              />
            </svg>
          </button>
        </div>
        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-teal-800 px-4 py-2">
            <Link
              to="/"
              className="block text-slate-100 hover:text-amber-400 py-2 transition-colors duration-300"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/terms-and-conditions"
              className="block text-slate-100 hover:text-amber-400 py-2 transition-colors duration-300"
              onClick={() => setIsMenuOpen(false)}
            >
              Terms
            </Link>
            <Link
              to="/privacy-policy"
              className="block text-slate-100 hover:text-amber-400 py-2 transition-colors duration-300"
              onClick={() => setIsMenuOpen(false)}
            >
              Privacy
            </Link>
          </div>
        )}
      </nav>

      {/* Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms-and-conditions" element={<Terms />} />
        <Route path="/privacy-policy" element={<Privacy />} />
      </Routes>

      {/* Footer */}
      <footer className="bg-teal-900 text-white py-12 animate-fade-in">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h3 className="text-2xl font-bold mb-4 text-amber-200">SALINAS TRADING LLC</h3>
          <p className="text-slate-300 mb-6 leading-relaxed">
            Your trusted partner in global trading and retail solutions.
          </p>
          <div className="flex justify-center space-x-4 mb-6">
            <a
              href="#"
              className="text-slate-300 hover:text-amber-400 transition-colors duration-300 filter hover:brightness-110"
            >
              Facebook
            </a>
            <a
              href="#"
              className="text-slate-300 hover:text-amber-400 transition-colors duration-300 filter hover:brightness-110"
            >
              Twitter
            </a>
            <a
              href="#"
              className="text-slate-300 hover:text-amber-400 transition-colors duration-300 filter hover:brightness-110"
            >
              LinkedIn
            </a>
          </div>
          <div className="space-x-4">
            <Link
              to="/terms-and-conditions"
              className="text-slate-300 hover:text-amber-400 transition-colors duration-300 filter hover:brightness-110"
            >
              Terms and Conditions
            </Link>
            <Link
              to="/privacy-policy"
              className="text-slate-300 hover:text-amber-400 transition-colors duration-300 filter hover:brightness-110"
            >
              Privacy Policy
            </Link>
          </div>
          <p className="mt-6 text-slate-400">© 2025 SALINAS TRADING LLC. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

function Home() {
  return (
    <div>
      {/* Hero Section */}
      <section
        className="hero bg-gradient-to-r from-teal-900 to-amber-600 text-white py-48 h-[800px] relative bg-center"
        style={{
          backgroundImage:
            'url(https://media-hosting.imagekit.io/6befdd3ec5c64544/temmp.jpeg?Expires=1839848129&Key-Pair-Id=K2ZIVPTIP2VGHC&Signature=twBD6gEOBVGfSly-NOtKlZ2nY42JlFf3yYxG0oLAyPhoOJl8ByizmDZO2sPr4l4HSI~1cuQMot-KPBdfENnf9-cGTkTGx9iPuOIIowB6SO7gw50j5nAD6U13b2aCtoK69BNkJz8Ofb~yHGd1GrXtCT9Im1urJX4ljruUoFtZmtkPVCmz6VK3aMZyO~zqEGsGt-fR1NH78Ulp~CaGJYdI7nb45urK5HPZSJpqVd6Pffi8eBTWcxUnYCwF6QlQKf~5T2uXbylHzSzaf7pDn4wSJTo1QST711aeMiUEJ9ShwiyYH9Bhqj-G8dr3Mx1L3D4hsVKP5BuAywYnkARjmqk-ZA__)',
            backgroundSize: '2000px auto',
        }}
      >
        <div className="absolute inset-0 bg-teal-900/50"></div>
        <div className="max-w-7xl mx-auto px-4 text-center animate-fade-in relative z-10">
          <h1 className="text-6xl md:text-7xl font-bold mb-6 text-slate-100 text-shadow-lg">
            Empowering Global Commerce
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto text-slate-200 leading-relaxed">
            SALINAS TRADING LLC delivers innovative trading and retail solutions, connecting markets and customers worldwide with excellence.
          </p>
          <Link
            to="/#services"
            className="inline-block bg-amber-400 text-teal-900 font-semibold py-3 px-8 rounded-full hover:bg-teal-600 hover:text-amber-200 transition-all duration-300 transform hover:scale-105 filter hover:brightness-110"
          >
            Explore Our Services
          </Link>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-slate-800 text-center mb-12 animate-slide-up">Our Services</h2>
          <div className="grid md:grid-cols-2 gap-8">
            {/* General Trading Card */}
            <div className="bg-white p-8 rounded-lg shadow-md border border-teal-500 hover:shadow-xl transition-all duration-300 transform hover:scale-105 animate-slide-up">
              <h3 className="text-2xl font-semibold text-slate-800 mb-4">General Trading</h3>
              <p className="text-slate-600 leading-relaxed mb-6">
                We specialize in sourcing and distributing high-quality products across global markets. Our robust supply chain ensures timely delivery and competitive pricing for businesses of all sizes.
              </p>
              <Link
                to="/#services"
                className="text-teal-600 hover:text-amber-400 hover:underline transition-colors duration-300 filter hover:brightness-110"
              >
                Learn More
              </Link>
            </div>
            {/* Retail Sale Card */}
            <div className="bg-white p-8 rounded-lg shadow-md border border-teal-500 hover:shadow-xl transition-all duration-300 transform hover:scale-105 animate-slide-up">
              <h3 className="text-2xl font-semibold text-slate-800 mb-4">Online Retail</h3>
              <p className="text-slate-600 leading-relaxed mb-6">
                Our e-commerce platform offers a seamless shopping experience, delivering products directly to your doorstep with a focus on convenience and customer satisfaction.
              </p>
              <Link
                to="/#services"
                className="text-teal-600 hover:text-amber-400 hover:underline transition-colors duration-300 filter hover:brightness-110"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-slate-800 text-white">
        <div className="max-w-7xl mx-auto px-4 text-center animate-fade-in">
          <h2 className="text-4xl font-bold text-slate-100 mb-6">About SALINAS TRADING LLC</h2>
          <div className="w-20 h-1 bg-amber-400 mx-auto mb-6"></div>
          <p className="text-lg text-slate-300 leading-relaxed max-w-3xl mx-auto">
            Founded with a vision to bridge markets, SALINAS TRADING LLC is a leader in general trading and online retail. Our commitment to quality, innovation, and customer-centric solutions drives us to deliver exceptional value worldwide.
          </p>
        </div>
      </section>
    </div>
  );
}

export default App;